// extracted by mini-css-extract-plugin
module.exports = {"TitleContainer":"Module_TitleContainer__8mR86","Title":"Module_Title__JyRK5","LevelContainer":"Module_LevelContainer__f6Csc","LevelName":"Module_LevelName__pkYa2"};